import { RenewVisaPresentPage } from "@/features/renew-visa/pages/RenewVisaPresent";

const RenewVisaPresent = () => {
  return <RenewVisaPresentPage />;
};

export default RenewVisaPresent;
